import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useGlobalContext } from '../../utils/Context'
import Sidebar from './components/Sidebar'
import Topbar from './components/Topbar'
import './Dashboard.scss'
import Home from './dashPages/home/Home'
import BookShipment from './dashPages/delivery/book/BookShipment'
import Bookings from './dashPages/bookings/Bookings'
import Booking from './dashPages/bookings/Booking'
import Transactions from './dashPages/transactions/Transactions'
import Trackings from './dashPages/tracking/Trackings'
import Tracking from './dashPages/tracking/Tracking'
import Customers from './dashPages/customers/Customers'
import Customer from './dashPages/customers/Customer'
import KycReview from './dashPages/kyc/KycReview'
import KycDetail from './dashPages/kyc/KycDetail'
import ShipperIds from './dashPages/shipperIds/ShipperIds'
import ShipperIdDetail from './dashPages/shipperIds/ShipperIdDetail'
import SenderIdChecks from './dashPages/senderIds/SenderIdChecks'
import Admins from './dashPages/admins/Admins'
import UserRates from './dashPages/zoneRates/UserRates'
import AggregatorRates from './dashPages/zoneRates/AggregatorRates'
import SuperAggregatorRates from './dashPages/zoneRates/SuperAggregatorRates'
import Admin from './dashPages/admins/Admin'
import AdminLogs from './dashPages/admins/AdminLogs'
import RequestLogs from './dashPages/admins/RequestLogs'
import Drafts from './dashPages/bookings/Drafts'
import OverDraft from './dashPages/bookings/OverDraft'
import OnboardingRequests from './dashPages/business/OnboardingRequests'
import Businesses from './dashPages/business/Businesses'
import Business from './dashPages/business/Business'
import APIBookings from './dashPages/bookings/APIBookings'
import CancelledBookings from './dashPages/bookings/CancelledBookings'
import Analytics from './dashPages/analytics/Analytics'
import DebtCustomers from './dashPages/customers/DebtCustomers'
import APITransactions from './dashPages/transactions/APITransactions'
import Notifications from './dashPages/notifications/Notifications'
import BalanceCustomers from './dashPages/customers/BalanceCustomers'
import FloatingBookings from './dashPages/bookings/FloatingBookings'
import FloatingBooking from './dashPages/bookings/FloatingBooking'
import PortalConfig from './dashPages/portalConfig/PortalConfig'
import Tags from './dashPages/tags/Tags'
import AllBookings from './dashPages/bookings/AllBookings'
import DebtBatches from './dashPages/debts/DebtBatches'
import GracePeriods from './dashPages/debts/GracePeriods'
import DebtSummary from './dashPages/debts/DebtSummary'
import WeightDiscrepancy from './dashPages/weightDiscrepancy/WeightDiscrepancy'
import WeightDiscrepancyInvoice from './dashPages/weightDiscrepancy/WeightDiscrepancyInvoice'
import WeightDiscrepancyAnalytics from './dashPages/weightDiscrepancy/WeightDiscrepancyAnalytics'
import HeavyWeightRates from './dashPages/heavyWeightRates/HeavyWeightRates'
import MidWeightRates from './dashPages/midWeightRates/MidWeightRates'
import Escalations from './dashPages/escalations/Escalations'
import Escalation from './dashPages/escalations/Escalation'
import KnowledgeBase from './dashPages/knowledgeBase/KnowledgeBase'
import KnowledgeBaseForm from './dashPages/knowledgeBase/KnowledgeBaseForm'
import QuickQuote from './dashPages/quote/QuickQuote'
function Dashboard() {
  const { page } = useParams()
  const { closeSideBar, ensureTags } = useGlobalContext()

  // The tag provider mounts on the login page, before a token exists, and is
  // never remounted by the post-login navigate(). This is the first mount that
  // is guaranteed to be authenticated, so it is where the tags get loaded.
  // ensureTags() is idempotent, so repeat mounts cost nothing.
  useEffect(() => {
    ensureTags?.()
  }, [])

  const activePage = () => {
    let active = ''
    switch (page) {
      case 'home':
        return <Home />
        break
      case 'export':
      case 'import':
      case 'domestic':
        return <BookShipment key={page} kind={page as 'export' | 'import' | 'domestic'} />
      case 'bookings':
        return <Bookings />
      case 'api-bookings':
        return <APIBookings />
      case 'booking':
        return <Booking />
      case 'drafts':
        return <Drafts />
      case 'transactions':
        return <Transactions />
      case 'api-transactions':
        return <APITransactions />
      case 'over-drafts':
        return <OverDraft />
      case 'cancelled-bookings':
        return <CancelledBookings />
      case 'floating-bookings':
        return <FloatingBookings />
      case 'floating-booking':
        return <FloatingBooking />
      case 'all-bookings':
        return <AllBookings />

      case 'trackings':
        return <Trackings />
      case 'tracking':
        return <Tracking />
      case 'customers':
        return <Customers />
      case 'customer':
        return <Customer />
      case 'kyc-review':
        return <KycReview />
      case 'kyc-request':
        return <KycDetail />
      case 'shipper-ids':
        return <ShipperIds />
      case 'shipper-id':
        return <ShipperIdDetail />
      case 'sender-id-checks':
        return <SenderIdChecks />
      case 'admins':
        return <Admins />
      case 'admin':
        return <Admin />
      case 'admin-logs':
        return <AdminLogs />
      case 'activity':
        return <RequestLogs />
      case 'user-rates':
        return <UserRates />
      case 'aggregators-rates':
        return <AggregatorRates />
      case 'super-aggregators-rates':
        return <SuperAggregatorRates />
      case 'onboarding-requests':
        return <OnboardingRequests />
      case 'businesses':
        return <Businesses />
      case 'business':
        return <Business />
      case 'analytics':
        return <Analytics />
      case 'debt-customers':
        return <DebtCustomers />
      case 'balance-customers':
        return <BalanceCustomers />
      case 'notifications':
        return <Notifications />
      case 'portal-config':
        return <PortalConfig />
      case 'tags':
        return <Tags />
      case 'debt-batches':
        return <DebtBatches />
      case 'grace-periods':
        return <GracePeriods />
      case 'debt-summary':
        return <DebtSummary />
      case 'weight-discrepancy':
        return <WeightDiscrepancy />
      case 'weight-discrepancy-invoice':
        return <WeightDiscrepancyInvoice />
      case 'weight-discrepancy-analytics':
        return <WeightDiscrepancyAnalytics />
      case 'heavy-weight-rates':
        return <HeavyWeightRates />
      case 'mid-weight-rates':
        return <MidWeightRates />
      case 'escalations':
        return <Escalations />
      case 'escalation':
        return <Escalation />
      case 'knowledge-base':
        return <KnowledgeBase />
      case 'knowledge-base-entry':
        return <KnowledgeBaseForm />
      case 'quick-quote':
        return <QuickQuote />
      default:
        break
    }
    return active
  }
  return (
    <div className='dashboard flex' onClick={closeSideBar}>
      <Sidebar page={page} />
      <div className='main'>
        <Topbar page={page} />
        <div className='main-body'>{activePage()}</div>
      </div>
    </div>
  )
}

export default Dashboard
